import GenericButton from "@ui-components/Button/GenericButton";
import GenericCheckbox from "@ui-components/Checkbox/GenericCheckbox";
import GenericInput from "@ui-components/Input/GenericInput";
import React, { useState } from "react";

interface OrderOverviewConfirmationProps {
  onAcceptChange: (accepted: boolean) => void;
}

const OrderOverviewConfirmation: React.FC<OrderOverviewConfirmationProps> = ({
  onAcceptChange,
}) => {
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [newDescription, setNewDescription] = useState('');

  const handleCheckboxChange = (checked: boolean) => {
    setCheckboxChecked(checked);
    onAcceptChange(checked);
  };

  return (
    <div className="flex p-6 flex-wrap">
      <div className="flex p-5 rounded-md border">
        <p className="text-sm text-semantic-text-primary">
          1. Acceptance of Terms<br />
          By accessing and using our services, you agree to be bound by these Terms and Conditions.<br />
          2. Service Description<br />
          We provide network infrastructure services, including port configuration and management.<br />
          3. User Obligations<br />
          You agree to use our services in compliance with all applicable laws and regulations.<br />
          4. Payment Terms<br />
          Fees for our services are due as specified in your service agreement.<br />
          5. Termination<br />
          We reserve the right to terminate services for violation of these terms or non-payment.<br />
          6. Limitation of Liability<br />
          Our liability is limited to the extent permitted by applicable law.<br />
          7. Privacy Policy<br />
          Lorem ipsum dolor sit amet consectetur. Varius eu vivamus tortor dictumst. Lectus quam tincidunt tellus nibh. Felis enim sit lorem id faucibus dapibus orci est. Lobortis dui fermentum accumsan eu.<br />
          8. Another item<br />
          Lorem ipsum dolor sit amet consectetur. Varius eu vivamus tortor dictumst. Lectus quam tincidunt tellus nibh. Felis enim sit lorem id faucibus dapibus orci est. Lobortis dui fermentum accumsan eu.<br />
        </p>
      </div>
      <div className="mt-2 w-full border-b border-gray-300">
        <GenericCheckbox
          label="I accept terms and conditions"
          checked={checkboxChecked}
          onChange={handleCheckboxChange}
          className="mb-5 mt-5"
        />
        <div className="flex justify-center w-full mb-2">
          <GenericInput
            placeholder="Purchase Order"
            value={newDescription}
            onChange={setNewDescription}
            className="text-small w-small"
            tooltipText="You can set a name to identify your order, this is optional."
          />
        </div>
      </div>
      <div className="flex justify-center w-full mt-3">
        <GenericButton
          label="I need help from an expert"
          variant="secondary"
          size="sm"
          onClick={() => {
            window.Intercom?.('showNewMessage');
          }}
        />
      </div>
    </div>
  );
};

export default OrderOverviewConfirmation;

